import PropTypes from 'prop-types';
import './Banner.css';

export default function Banner({ type = 'success', title, message, onClose }) {
  return (
    <div className={`banner banner--${type}`}>
      <div className="banner__icon">
        <svg
          width="1rem"
          height="1rem"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#000" floodOpacity="0.2" />
            </filter>
          </defs>
          <circle
            cx="12"
            cy="12"
            r="10"
            className={`banner__circle banner__circle--${type}`}
            filter="url(#shadow)"
          />
          <path
            d="M9 12l2.5 2.5L16.5 9"
            fill="none"
            stroke="#fff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="banner__content">
        <div className="banner__title">{title}</div>
        <div className="banner__message">{message}</div>
      </div>
      <button className="banner__close" onClick={onClose} aria-label="Close">
        ×
      </button>
    </div>
  );
}

Banner.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'error']),
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
